<template>
    <div>
        <Menu :menu="menu"></Menu>
        <div id="page-wrap" class="main-container">
            <Header color="red" />
            <center-container>
                <slot />
            </center-container>
        </div>
    </div>
</template>

<script>
    import Header from "components/navigation/Header";
    import Menu from "components/navigation/Menu";

    export default {
        name: "Default",
        components: {
            Header,
            Menu
        },
        data() {
            return {
                menu: [
                    {
                        title: "Создание пользователя",
                        link: "/admin/register-company",
                        access: "owners"
                    },
                    {
                        title: "Создание поселка",
                        link: "/admin/map",
                        access: "owners"
                    },
                    {
                        title: "Поселки пользователя",
                        link: "/admin/users-villages",
                        access: "owners"
                    }
                ]
            };
        }
    };
</script>

<style>
    @import 'https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css';
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
    body {
        margin: 0;
        font-family: "Roboto", sans-serif;
        color: #2e426b;
    }
    ul {
        margin: 0;
        padding: 0;
        list-style-type: none;
    }
    .bm-overlay {
        background: white !important;
    }
    .main {
        &-container {
            min-height: calc(100vh - 70px);
            min-width: calc(100vw - 70px);
        }
        &.row {
            display: flex;
            align-items: flex-start;
        }
    }

    .section_menu {
        display: flex;
        justify-content: center;
        position: absolute;
        right: 0;
        left: 0;
        top: 5px;
        & a {
            display: flex;
            margin-right: 10px;
            text-decoration: none;
            padding: 5px;
            border: 1px solid #2e426b;
            border-radius: 4px;
            font-weight: bold;
            font-size: 15px;
            color: #2e426b;
            background: white;
            &.router-link-active {
                background: #2e426b;
                color: white;
            }
        }
    }

    .content {
        min-width: calc(100vw - 40px);
        margin: 20px auto;
        &_title {
            text-align: center;
            width: 100%;
            font-size: 20px;
            font-weight: bold;
        }
        &_row {
            display: flex;
            margin: 10px 0;
            border: #46bd87 solid 1px;
            justify-content: space-between;
            align-content: center;
            align-items: center;
            border-radius: 4px;
            & div {
                padding: 10px;
                display: flex;
            }
            &.col-4 {
                & div {
                    width: 25%;
                }
            }
            &.center {
                & div {
                    justify-content: center;
                }
            }
            &.bold {
                & div {
                    font-weight: bold;
                }
            }
            & button {
                background: #46bd87;
                color: white;
                padding: 10px;
                border: none;
                height: 40px;
                cursor: pointer;
                &.cancel {
                    background: gainsboro;
                }
            }
        }
    }

    /*form style*/
    .waite {
        height: 50px;
        margin: 0 auto;
    }
    .form-field {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        & label {
            margin-top: 15px;
            font-size: 15px;
            font-weight: bold;
        }
        & button {
            background: #46bd87;
            border: 1px solid white;
            color: white;
            padding: 10px;
            font-size: 15px;
            font-weight: bold;
            border-radius: 3px;
            margin-top: 10px;
            cursor: pointer;
            &.cancel {
                background: gainsboro;
            }
        }
        & label,
        & input,
        & button,
        & select {
            display: block;
            width: 100%;
        }
        & .disable {
            pointer-events: none;
            background: darkgray;
        }
    }
    .form-row {
        max-width: 300px;
        display: flex;
        margin: 25px 15px 0;
        flex-wrap: wrap;
        &-line {
            display: flex;
            flex-wrap: nowrap;
            max-width: none;
            &.col-4 .form-field {
                width: 25%;
            }
            & .form-field {
                padding: 3px;
            }
        }
    }
    .form-row-parse {
        display: flex;
        width: 100%;
        margin: 10px;
        & label {
            width: 10%;
        }
        & input {
            width: 70%;
        }
        & button {
            width: 10%;
            margin-left: 10px;
        }
        & .form-input-parse {
            display: flex;
            flex-wrap: wrap;
            margin-right: 10px;
            border: 1px solid #696969;
            border-radius: 4px;
            & label,
            & input,
            & select,
            & button {
                border: none;
                display: flex;
                width: 100%;
                padding: 5px;
            }
            & input {
                border-top: 1px solid #696969;
                border-bottom-left-radius: 4px;
                border-bottom-right-radius: 4px;
            }
        }
        & .form-button-parse {
            display: flex;
            flex-wrap: wrap;
            margin-right: 10px;
            justify-content: center;
            & button,
            & a {
                display: flex;
                align-items: center;
                text-decoration: none;
                justify-content: center;
                width: 100%;
                margin: 0;
                color: white;
                border: none;
                font-size: 15px;
                font-weight: bold;
                padding: 5px;
                border-radius: 4px;
                background: #46bd87;
                &.parse {
                    margin-top: 10px;
                }
                &.clear {
                    background: #2e426b;
                }
            }
        }
    }
    .button-container {
        display: flex;
        width: 100%;
    }

    .content_row .checkboxes {
        display: block;
    }
</style>
